import notify from "../../components/ACS-Dashboard/ACS-Blocks/Toast";
import {
  isActivatingExistingDynamicTab,
  isDynamicTabLimitReached,
} from "../utils/dynamicTabs";

const ADD_TAB_ACTION_SUFFIX = "/addTab";

const ACTION_SLICE_TO_STATE_KEY = {
  messages: "messages",
  orders: "orders",
  inventory: "inventory",
  contracts: "contracts",
  shipments: "shipments",
  invoices: "invoices",
  DocumentUploader: "documentUploader",
  Appointments: "appointments",
  manageTeam: "manageTeam",
  NotificationCenter: "notificationCenter",
  locations: "locations",
  resourceSelection: "resourceSelection",
};

const dynamicTabLimitMiddleware = (store) => (next) => (action) => {
  if (!action.type?.endsWith(ADD_TAB_ACTION_SUFFIX)) {
    return next(action);
  }

  const sliceName = action.type.slice(0, -ADD_TAB_ACTION_SUFFIX.length);
  const stateKey = ACTION_SLICE_TO_STATE_KEY[sliceName];

  if (!stateKey) {
    return next(action);
  }

  const sliceState = store.getState()[stateKey];

  if (!sliceState?.dynamicTabs) {
    return next(action);
  }

  if (
    isActivatingExistingDynamicTab(sliceState, action.payload) ||
    !isDynamicTabLimitReached(sliceState)
  ) {
    return next(action);
  }

  notify.error({
    title: "Open tab limit reached (10)",
    message: "Close unused tabs before proceeding to open a new tab.",
    options: { toastId: "max-tab-limit" },
  });

  return action;
};

export default dynamicTabLimitMiddleware;
